import { useState } from "react";
import ProfileForm from "../profile-form/ProfileForm";
import VideoUpload from "../video-upload/VideoUpload";

export default function UploadFlow() {
  const [step, setStep] = useState(1);
  const [profileData, setProfileData] = useState(null);

  return (
    <div>
      {step === 1 && (
        <ProfileForm
          onComplete={(data) => {
            setProfileData(data);
            setStep(2);
          }}
        />
      )}
      {step === 2 && (
        <VideoUpload
          profileData={profileData}
          onBack={() => setStep(1)}
        />
      )}
    </div>
  );
}
